import { render, staticRenderFns } from "./refer-coupon-select-dialog.vue?vue&type=template&id=ae145c1a&scoped=true&"
import script from "./refer-coupon-select-dialog.vue?vue&type=script&lang=js&"
export * from "./refer-coupon-select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./refer-coupon-select-dialog.vue?vue&type=style&index=0&id=ae145c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae145c1a",
  null
  
)

export default component.exports